import { SpecialOfferProps } from '../types';
import { StyledMe2onSpecialOffer } from './style';
import { Box } from '@mui/system';
import { Stack } from '@mui/material';
import { Me2onSaleBadge } from 'components/Badge/Sale/Me2onSaleBadge';
import { EBundlesInternalViewModel } from 'utils/enums';
import { BundlePrice } from 'components/BundlePrice';
import { Me2onProduct } from './Products/Me2onProduct';

export const Me2onSpecialOffer: React.FC<SpecialOfferProps> = ({
  prices,
  dataTestId,
  productsList,
  availability,
  backgroundColor,
  backgroundImage,
  selectOffer,
  salePercentage = 0,
  salePercentageDisplayType,
  buttonColor,
  isFree,
  collectText,
  availabilityText,
  timer,
}) => {
  return (
    <StyledMe2onSpecialOffer
      onClick={selectOffer}
      backgroundColor={backgroundColor}
      backgroundImage={backgroundImage}
      buttonColor={buttonColor}
      data-testid={dataTestId}
    >
      <Box className="container">
        {salePercentage > 0 && (
          <Me2onSaleBadge
            salePercentage={salePercentage}
            salePercentageDisplayType={salePercentageDisplayType}
          />
        )}
        <Box className="products">
          {productsList.slice(0, 3).map((product, index) => (
            <Me2onProduct
              key={index}
              productImage={product.images.product}
              quantityDisplay={product.quantityDisplay}
              isMainProduct={
                !!(salePercentage > 0 && product.strokedSaleQuantity)
              }
              textColor={product.textFontColorHex}
              strokedSaleQuantity={product.strokedSaleQuantity}
            />
          ))}
        </Box>
        <Box className="price-container">
          <Stack direction="row" spacing={2} justifyContent="center">
            {timer && <Box className="timer">Ends in {timer}</Box>}
            {availabilityText && availability && (
              <Box className="availability">
                {availabilityText} {availability.remaining} /{' '}
                {availability.total}
              </Box>
            )}
          </Stack>
          <BundlePrice
            prices={prices}
            type={EBundlesInternalViewModel.ME2ON}
            whiteStripe={true}
            isFree={isFree}
            buttonText={collectText}
          />
        </Box>
      </Box>
    </StyledMe2onSpecialOffer>
  );
};
